<template>

  <div class="product-add" v-loading="loading">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form"  label-width="150px" v-if="!loading">
      <!--添加门店-->
      <div class="common-form">设置</div>
      <el-form-item label="是否开启排行榜：">
        <el-radio-group v-model="form.is_open">
          <el-radio :label="0">关闭</el-radio>
          <el-radio :label="1">开启</el-radio>
        </el-radio-group>
      </el-form-item>

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>

</template>

<script>
  import RankingApi from '@/api/ranking.js';
  import { formatModel } from '@/utils/base.js';
  export default {
    components:{},
    data() {
      return {
        /*是否正在加载*/
        loading: true,
        /*form表单数据*/
        form: {
          is_open: 0,//
        },

      };
    },
    created() {
      this.getParams()
    },

    methods: {

      /*获取配置数据*/
      getParams() {
        let self = this;
        RankingApi.getSetting({}, true)
          .then(res => {
            let vars = res.data.vars.values;
            self.form = formatModel(self.form, vars);
            self.form.is_open = vars.is_open || self.form.is_open;
            self.loading=false;
          })
          .catch(error => {
            self.loading=false;
          });
      },

      /*提交*/
      onSubmit() {
        let self = this;
        let params = this.form;
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            RankingApi.saveSetting(params, true)
              .then(data => {
                self.loading = false;
                self.$message({
                  message: '恭喜你，设置成功',
                  type: 'success'
                });
              })
              .catch(error => {
                self.loading = false;
              });
          }
        });
      },
      //监听复选框选中
      handleCheckedGetLog(e) {

      },
    }

  };
</script>
<style>
  .tips {
    color: #ccc;
  }
</style>



// WEBPACK FOOTER //
// src/views/plus/ranking/setting/index.vue